/* ========================================================================= */
/* Background Color */
/* ========================================================================= */

/**
 * @function getBgColor
 * @param {string} backgroundColor
 * @return {string}
 *
 * Return corresponding background classname
 */
export const getBgColor = (backgroundColor) => {
    let bg = '';

    switch (backgroundColor) {
    case 'Blue':
        bg = '#C2E8EA';
        break;
    case 'Green':
        bg = '#DFE2AF';
        break;
    case 'Peach':
        bg = '#F7E6DB';
        break;
    case 'Yellow':
        bg = '#F3F2A9';
        break;
    case 'Orange':
        bg = '#F3F2A9';
        break;
    case 'Teal':
        bg = '#F3F2A9';
        break;
    case 'Asphalt':
        bg = '#000000';
        break;
    case 'Brand Orange':
        bg = '#FC5200';
        break;
    case 'Sand':
        bg = '#F3F2ED';
        break;
    }

    return bg;
};

/**
 * @function getColorStyles
 * @param {string} backgroundColor
 * @return {string}
 *
 * Return corresponding background and border colours
 */
export const getColorStyles = (backgroundColor) => {
    let style = {
        backgroundColor: '#FFF', // white
        borderColor: '#ECECEC' // border-grey
    };

    switch (backgroundColor) {
    case 'Blue':
        style = {
            backgroundColor: '#C2E8EA', // pastel-blue
            borderColor: '#B6E4EC' // border-blue
        };
        break;
    case 'Green':
        style = {
            backgroundColor: '#DFE2AF', // pastel-green
            borderColor: '#DDE1A5' // border-green
        };
        break;
    case 'Peach':
        style = {
            backgroundColor: '#F7E6DB', // pastel-peach
            borderColor: '#FADFD1' // border-peach
        };
        break;
    case 'Yellow':
        style = {
            backgroundColor: '#F3F2A9', // pastel-yellow
            borderColor: '#F0EFA5' // border-yellow
        };
        break;
    case 'Orange':
        style = {
            backgroundColor: '#FC5200', // orange
        };
        break;
    case 'Teal':
        style = {
            backgroundColor: '#78DAE5', // teal
        };
        break;
    case 'Instagram':
        style = {
            backgroundColor: '#8a3ab9'
        };
        break;
    case 'Twitter':
        style = {
            backgroundColor: '#1DA1F2'
        };
        break;
    case 'X':
        style = {
            backgroundColor: '#101419'
        };
        break;
    case 'Facebook':
        style = {
            backgroundColor: '#4267B2'
        };
        break;
    }

    return style;
};

/* =========================================================================  */
/* Methods(s) */
/* =========================================================================  */

/**
 * @function findModuleAnchors
 * @param {*} data
 * @returns {array}
 * Finds all anchor modules
 */
export const findModuleAnchors = (data) => {
    let anchors = [];

    if (Array.isArray(data)) {
        data.forEach((d) => {
            anchors = anchors.concat(findModuleAnchors(d));
        });
    } else if (data && typeof data === 'object' && data.__typename) {
        switch (data.__typename) {
        case 'BvaModuleAnchor':
            anchors.push(data);
            break;
        default:
            Object.keys(data).forEach((k) => { anchors = anchors.concat(findModuleAnchors(data[k])); });
            break;
        }
    }

    return anchors;
};

/**
 * @function getAllModules
 * @param {*} data
 * @returns {array}
 * Concatenates all module arrays
 */
export const getAllModules = (page) => {
    if (!page) {return null;}

    let modules = [];
    Object.keys(page).map(key => {
        if(key.includes('modules')) {
            modules = [...modules, ...page[key].items];
        }
    });

    return modules;
};
